// extracted by mini-css-extract-plugin
export default {"iFrame":"mSC3JqZ"};